module.exports = __webpack_public_path__ + "img/13.1951b9f8.png";